import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { addIntlProps } from 'utils/recompose/addIntlProps';
import messages from './messages';

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['orderDashboardLabel'],
  }),
);
